import { ComponentProps, JSXElementConstructor, ReactNode } from 'react';


export function OptionalWrapper<
    TComponent extends JSXElementConstructor<any> = JSXElementConstructor<{ children?: ReactNode }>
>({
    Component, children, renderWrapper, ...props
}: { Component: TComponent, renderWrapper: boolean } & ComponentProps<TComponent>) {
    return renderWrapper ? (
        <Component {...props}>
            {children}
        </Component>
    ) : children;
}
